import { useEffect, useMemo, useState } from "react";

export default function ProjectSearchBox({
  handleSearch,
  isCategorieSelect,
  setIsCategorieSelect,
  yearList,
  searchKeyword = "",
  onSearchChange,
  selectedYear,
  onYearChange,
  placeholder = "Search project",
}) {
  const currentYear = String(new Date().getFullYear());
  const activeYear = selectedYear ?? isCategorieSelect ?? currentYear;
  const handleKeywordChange = onSearchChange ?? handleSearch;
  const handleYearChange = onYearChange ?? setIsCategorieSelect;
  const [inputValue, setInputValue] = useState(searchKeyword ?? "");

  const safeYearList = useMemo(() => {
    const currentYearNumber = Number(currentYear);
    const years =
      Array.isArray(yearList) && yearList.length > 0 ? yearList : [currentYear];

    return Array.from(
      new Set([...years, activeYear, currentYear].map((year) => String(year))),
    )
      .map((year) => Number(year))
      .filter(
        (year) =>
          Number.isInteger(year) && year > 0 && year <= currentYearNumber,
      )
      .sort((a, b) => a - b)
      .map((year) => String(year));
  }, [activeYear, currentYear, yearList]);

  useEffect(() => {
    setInputValue(searchKeyword ?? "");
  }, [searchKeyword]);

  useEffect(() => {
    if (typeof handleKeywordChange !== "function") return undefined;

    const timer = window.setTimeout(() => {
      handleKeywordChange(inputValue.trim());
    }, 350);

    return () => window.clearTimeout(timer);
  }, [handleKeywordChange, inputValue]);

  return (
    <div className="searchBox">
      <p>{activeYear}</p>

      <ul className={activeYear ? "active" : ""}>
        {safeYearList.map((year) => (
          <li
            onClick={() => handleYearChange?.(year)}
            key={year}
            aria-current={year === activeYear ? "true" : undefined}
          >
            {year}
          </li>
        ))}
      </ul>

      <div>
        <input
          onChange={(event) => setInputValue(event.target.value)}
          value={inputValue}
          type="text"
          placeholder={placeholder}
          aria-label={placeholder}
        />
      </div>
    </div>
  );
}
